// Side panels on /main sit in two columns. Chat Bot opens in the right
// column with Quick Email. wrapper-main-right-column shifts that column
// past the left column (1324px + 420px) so the panels do not overlap.
function chatPanelClass(path) {
  if (path === '/main') {
    return 'chat-wrapper wrapper-absolute-position-3 wrapper-main-right-column';
  }
  if (path === '/documents') {
    return 'chat-wrapper wrapper-absolute-position-3';
  }
  if (path === '/lease-search') {
    return 'chat-wrapper wrapper-absolute-position-2';
  }
  return 'chat-wrapper';
}

// On /main the work orders panel is .wrapper-absolute-position (top and
// height). Chat Bot sits beside it, so use that same box. Other routes
// already share a wrapper height with work orders.
function chatPanelBoxStyle(path) {
  if (path === '/main') {
    return { top: '57px', height: '856px' };
  }
  return {};
}

module.exports = { chatPanelClass, chatPanelBoxStyle };
